export default "__VITE_ASSET__258949bf__"